import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo:'/tech_materials',pathMatch:'full'},
  { path: 'tech_materials', loadChildren: () => import('./site/site.module').then(m => m.SiteModule)},
  { path: '**', redirectTo:'/tech_materials',pathMatch:'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
